import { HYGRAPH_PAGE_REGISTRATION_CONSENT_ID, HYGRAPH_PAGE_REGISTRATION_MARKETING_CONSENTS_ID } from 'constants/hygraphShemeId';
import { richTextFragment, systemFields } from 'petdna-lib-uicomponents/hygraph';

export const consentsFragment = `... on ConsentItem {
  ${systemFields}
  name
  title
  content {
    ${richTextFragment}
  }
  required
  consentId
}`;

export const registrationConsentsQuery = `query page($id: ID = "${HYGRAPH_PAGE_REGISTRATION_CONSENT_ID}") { 
  pageRegistrationConsent(where: {id: $id}) { 
    name
    consentItems {
      ${consentsFragment}
    } 
  } 
}`;

export const registrationMarketingConsentsQuery = `query page($id: ID = "${HYGRAPH_PAGE_REGISTRATION_MARKETING_CONSENTS_ID}") { 
  pageRegistrationConsent(where: {id: $id}) { 
    name
    consentItems {
      ${consentsFragment}
    } 
  } 
}`;
